import { AfterViewChecked, AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { DomEventService } from 'src/app/common/dom-event/dom-event.service';
import { DhlFormControl } from '../../models/dhl-form-control';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { FormService } from '../../services/form.service';
import {TranslateService} from '@ngx-translate/core';
import { Constant } from 'src/app/shared/constants/constants';
import moment from 'moment';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';
import { APP_Constants } from 'src/app/app.constant';

@Component({
    selector: 'app-form-field-datepicker-v2',
    templateUrl: './form-field-datepicker-v2.component.html',
    styleUrls: ['./form-field-datepicker-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldDatepickerV2Component implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;
  @ViewChild('formControl',{static: false, read: ElementRef}) formControl: ElementRef;
  @ViewChild('pickerContainer', {static: true, read: ElementRef}) pickerContainer: ElementRef;
  @ViewChild('datepicker', {static: true, read: ElementRef}) datepicker: ElementRef;
  @ViewChild('formControlOuter', {static: true, read: ElementRef}) formControlOuter: ElementRef;
  @ViewChild('calendarSection', {static: false, read: ElementRef}) calendarSection: ElementRef;

  // @Input() picker;

  placeholder: string= '';
  validationType: string = '';
  datepickerMetadata = {};
  filterDate: string = Constant.Filter_Popup_Status_All;
  pickerToggle:boolean = false;
  minDate: boolean = false;
  maxDate: boolean = false;
  futureDateLimit;
  pastDaysLimit: number;
  pastDateLimitObject: Date;
  form: any;
  hover: boolean;
  fieldControl: any;
  disabled: boolean = false;
  hidden: boolean = false;
  clickEventSubscription: Subscription;
  editableFromDate : any;
  editableToDate : any;

  commonData = Constant;
  time: string;
  timeObj = {
    "HoursPicker": "00",
    "MinutesPicker": "00"
  }
  compareType : any = null;
  filledInputDate: any;
  hoursArray: any[];
  jsonObject: { displayValue: string; value: string; };
  constructor(private _eref: ElementRef, private formService: FormService, private appService: AppService, private domEventService: DomEventService,private translate: TranslateService, private alphaService : AlphaService) { }

  holidayDates: string[] = [];
  toggleName: string = '';

  private shouldApplyDynamicRules(): boolean {
    const dynamicRules = this.configData?.dateEnabled?.dynamicRules;
    if (!dynamicRules) {
      return false;
    }

    // @ts-ignore
    const dependencyField = this.configData?.dependencyField;
    if (!dependencyField) {
      return true;
    }

    const dependencyControl = this.frmGroup?.get(dependencyField.key)?.value;
    const expediteFieldValue= dependencyControl?.value ? dependencyControl?.value : dependencyControl
    if (!dependencyControl) {
      return false;
    }

    return expediteFieldValue === dependencyField.value;
  }

  private initializeDateRange(): void {
    const dynamicRules = this.configData?.dateEnabled?.dynamicRules;
    if (!dynamicRules) {
      return;
    }

    if (!this.shouldApplyDynamicRules()) {
      this.editableFromDate = moment();
      this.editableToDate = null;
      return;
    }

    if (dynamicRules.from) {
      this.editableFromDate = this.getDynamicFromDate();
    } else {
      this.editableFromDate = null;
    }

    if (dynamicRules.to) {
      this.editableToDate = this.getDynamicFromDate();
    } else {
      this.editableToDate = null;
    }
  }
  ngOnInit() {
    if(this.configData.component == 'DATEPICKER' || this.configData.component == 'DATEPICKER_V2'){
      let val = this.appService.formatDateValueForCox(this.configData, this.frmGroup.get(this.configData.name).value);//set form field value
      this.frmGroup.get(this.configData.name).setValue(val);
      // this.formatFormValue(this.frmGroup.get(this.configData.name).value);//set form field value
      if((this.frmGroup.get(this.configData.name).value === "" || (this.frmGroup.get(this.configData.name).value).displayValue === "")
       && this.configData.dynamicDefaultValue && !this.configData?.excludeHolidays){
        let currentDate = new Date();
        let result = currentDate.setDate(currentDate.getDate() + parseInt(this.configData.dynamicDefaultValue.split("+")[1]));
        // WHY THIS PIECE OF CODE?
        // this.configData.defaultValue = new Date(result).toISOString().slice(0, -1);
        // this.formatFormValue(new Date(result).toISOString().slice(0, -1));
        let val = this.appService.formatDateValueForCox(this.configData, new Date(result).toISOString().slice(0, -1));
        this.frmGroup.get(this.configData.name).setValue(val);
      }

      if (this.configData?.excludeHolidays) {
        const url = APP_Constants.CALENDAR_HOLIDAY_URL + new Date().getFullYear() + '?customerCode=' + localStorage.getItem('customerCode') + '&userId=' + localStorage.getItem('userName');
        this.appService.makeHttpGetRequest(url).subscribe(response => {
          this.holidayDates = (response as any)?.data?.businessObject?.calendar?.closedDays?.default || [];
          this.showCurrentDate();
          const val = this.appService.formatDateValueForCox(
            this.configData,
            this.dateObject.toISOString().slice(0, -1)
          );
          this.frmGroup.get(this.configData.name).setValue(val);

        });
      }

      if(this.configData?.defaultTimeSet){
      const [datePart] = this.frmGroup.get(this.configData?.name)?.value?.split(" ");
        if (datePart !== "") {
          this.frmGroup.get(this.configData?.name).setValue(`${datePart} ${this.configData?.defaultTimeSet}`)
        }
      }

      let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
      if(this.configData.defaultOffSet && (filterObj?.[this.configData.name] === '' || filterObj?.[this.configData.name] === undefined)){
        let currentDate = new Date();
        let deafaultDate = currentDate.setDate(currentDate.getDate()- this.configData.defaultOffSet);
        if (this.configData.displayFormat) {
          this.filterDate = this.appService.getDateMonthFormat(new Date(deafaultDate), this.configData.displayFormat);
          let date = this.appService.getDateFormatDisplay(new Date(deafaultDate))
          this.sendDataForFilter(date,null)
          this.filterDate = moment(this.appService.getDateFormat(new Date(deafaultDate))).format(this.configData.displayFormat);
          this.frmGroup.get(this.configData.name).setValue(this.filterDate);
          if(this.configData.hasOwnProperty('fromDeliveryDate') || this.configData.hasOwnProperty('fromPickupDate') || this.configData.hasOwnProperty('toDeliveryDate')){
            filterObj[this.configData.name] = this.filterDate;
            this.alphaService.setFilteredObject('setFiltersValues', filterObj);
          }
        } else {
          this.filterDate = moment(this.appService.getDateFormat(new Date(deafaultDate))).format('MM/DD/yyyy');
          this.frmGroup.get(this.configData.name).setValue(this.filterDate);
        }
      }
    }

    if(this.configData.timePicker) {
      this.form = this.formInitialization();
    }

    this.fieldControl = this.frmGroup.get(this.configData.name);
    this.disabled = this.configData["disabled"];
    this.hidden = this.configData["hidden"];
    this.datepickerMetadata['fieldType'] = 'text';
    this.datepickerMetadata['fieldIcon'] = 'date';
    this.minDate = this.configData['pastDate'] == false ? true: false;
    this.maxDate = this.configData['futureDate'] == false ? true: false;
    this.futureDateLimit = this.configData['futureDateLimit']
    this.pastDaysLimit = this.configData['pastDaysLimit'];
    if (this.pastDaysLimit) {
      this.pastDateLimitObject = moment(new Date()).subtract(this.pastDaysLimit, 'd').toDate();
    }
    
      //passing Object
      if (this.configData['dynamicVisibility']) {
        if(this.configData['dynamicVisibility'].action == 'hidden'){
          this.hidden = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
        }else
        if(this.configData['dynamicVisibility'].action == 'disabled'){
          this.disabled = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
        }
      }
    this.clickEventSubscription = this.domEventService.click.subscribe((e: MouseEvent) => this.onWindowClick(e));
  }

  formInitialization(){
    let displayFormat=this.configData.displayFormat
    if(displayFormat && displayFormat.substr(displayFormat.length - 5)== "HH:mm" && this.configData.timeControls && !this.configData?.showDefaultTime){
    this.configData.timeControls[0].options
    this.hoursArray=[]
    let pickerContainer=this.configData.timeControls
    for(let i=0;i<24;i++){
      if(i<10)
      this.jsonObject = {'displayValue':"0"+i,'value':"0"+i};
      else
        this.jsonObject = {'displayValue':""+i,'value':""+i};
        this.hoursArray.push(this.jsonObject);
    }
    this.configData.timeControls[0].options= this.hoursArray
    pickerContainer=this.configData.timeControls.filter(element => {
        return element.name !== "AMPMPicker";
      })

      this.configData.timeControls=pickerContainer; 
    }  
    return this.formService.simpleFormCreation({controls: (this.configData.timeControls || this.configData.child_controls)});
  }

  // //CP-2434 : start : dateformat change on reset button
  // formatFormValue(data, setDate: boolean = false) {
  //   let formValue;
  //   let format = this.configData['format'];
  //   let type = this.configData['dataType'];
  //   // To show dates in human readable format on screen but send the date in UTC/ISO/machine readable use type: 'OBJECT' in template
  //   if (type === 'OBJECT') {
  //     if (typeof data !== 'object') {
  //       //START - CP-3509 : Fix the date picker time zone
  //       if(setDate){
  //         formValue = { 'displayValue': this.formService.getDateFormat(new Date(data)), 'value': data };
  //       }else{
  //         formValue = { 'displayValue': this.appService.getSystemDateMMddyyyy(data), 'value': data };
  //       }
  //       //END - CP-3509 : Fix the date picker time zone
  //     } else {
  //       formValue = data;
  //     }
  //   } else {
  //     formValue = data;
  //   }

  //   try {
  //     if (format === 'ISO') {
  //       if (typeof formValue === 'object' && formValue.value && formValue.value.length <= 10 && type === 'OBJECT') {
  //         formValue['value'] = new Date(this.appService.formatDateForExportDatepicker(formValue.value)).toISOString().slice(0, -1);
  //       } else if (typeof formValue === 'string' && formValue && formValue.length <= 10) {
  //         formValue = new Date(this.appService.formatDateForExportDatepicker(formValue)).toISOString().slice(0, -1);
  //       }
  //     }
  //   }
  //   catch (e) {
  //     formValue = formValue;
  //   }
  //   this.frmGroup.get(this.configData.name).setValue(formValue);
  // }//CP-2434 : end

  toggleHidden(bool){
    this.hidden = bool;
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']){
    this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    if (hidden){
        this.frmGroup.get(this.configData.name).reset();
        this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
  }

  getDynamicFromDate() {
    const validateObj = this.configData?.dateValidation;

    const now = validateObj?.useSystemTime
      ? moment().add(validateObj?.addInUTC)
      : moment().utc().add(validateObj?.addInUTC);

    let currentDay = now.format('ddd').toUpperCase();
    let getFormatedTime = moment(validateObj?.cuttOffTime, validateObj?.timeFormat); //Get the current time
    let getCurrentUTCTime = now.format(validateObj?.timeFormat);
    let cutOffTimeVailidation = moment(getCurrentUTCTime, validateObj?.timeFormat).isAfter(getFormatedTime);

    let calculatedDate;
    let addedDays;

    // Friday after cutoff
    if (
      cutOffTimeVailidation &&
      validateObj?.specialCutOffDays?.indexOf(currentDay) > -1 &&
      validateObj?.specialCutoffFallOn?.[currentDay] !== undefined
    ) {
      calculatedDate = now
        .clone()
        .add(validateObj?.specialCutoffFallOn[currentDay], 'days')
        .set(validateObj?.defaultTime);
    }
    // Saturday / Sunday
    else if (
      validateObj?.cuttOffWeekend?.indexOf(currentDay) > -1 &&
      validateObj?.cuttOfDayFallOn?.[currentDay] !== undefined
    ) {
      calculatedDate = now.clone().add(validateObj?.cuttOfDayFallOn?.[currentDay], 'days').set(validateObj?.defaultTime);
    }
    // Existing logic
    else {
      addedDays = cutOffTimeVailidation ? validateObj?.cuttOffTimeAfter : validateObj?.cuttOffTimeBefore;

      calculatedDate = now.clone().add(addedDays).set(validateObj?.defaultTime);
      if (validateObj?.allowedWeekend == true) {
        // addedDays = 0;
        calculatedDate = calculatedDate;
      } else {
        while (validateObj?.cuttOffWeekend?.indexOf(calculatedDate.format('ddd').toUpperCase()) > -1) {
          calculatedDate = calculatedDate.add(addedDays, 'days');
        }
      }
    }

    return calculatedDate;
  }

  shouldDisableDayByLimit(day: number, i: number) {
    const shownDate = new Date(this.updatedYear, this.updatedMonth, i + 1);
    return shownDate < this.pastDateLimitObject;
  }

  ngAfterViewInit() {
    if (this.configData['storeDataName']) {
      if (sessionStorage.getItem(this.configData['storeDataName'])) {
        let dateLocal = JSON.parse(sessionStorage.getItem(this.configData['storeDataName']));
        this.filterDate = dateLocal;
        this.sendDataForFilter(dateLocal, null);
      }
    }
    this.placeholder = this.configData.placeHolder;
    this.toggleDisable(this.configData['disabled']);
    this.fieldValueValidation(this.configData.validation);
    //get the values from fields
    if (this.configData?.dateEnabled) {
      const dateEnabledFrom = this.configData?.dateEnabled?.from;
      const dateEnabledTo = this.configData?.dateEnabled?.to;
        const dynamicRules = this.configData?.dateEnabled?.dynamicRules;

      if (dynamicRules) {
        this.initializeDateRange();
      }  else {
      this.editableFromDate = dateEnabledFrom === 'today' ? moment() : dateEnabledFrom?.includes('-') ? moment().subtract(parseInt(dateEnabledFrom.split('-')[1]), dateEnabledFrom.split('-')[2]) : this.frmGroup.get(dateEnabledFrom).value;
      }
      const getMonth = dateEnabledTo?.includes('-') ? parseInt(dateEnabledTo.split('-')[0]) : false;
      this.editableToDate = dateEnabledTo === 'today' ? moment() : getMonth ? moment().add(getMonth, dateEnabledTo.split('-')[1]) : this.frmGroup.get(dateEnabledTo).value;
      let values = this.frmGroup.get(this.configData.name)?.value
      if(values && values?.length > 0){
        setTimeout(()=>{
          this.appService.compareTwoDates('', this.configData, this.frmGroup);
        }, 100)

      };
     } else if (this.configData?.dateValidation) {
       let values = this.frmGroup.get(this.configData.name)?.value
       if (values && values?.length > 0) {
         setTimeout(() => {
           this.appService.compareTwoDates('', this.configData, this.frmGroup);
         }, 100)
       };
     }
    //End
    //Alpha - Set validation values when date availble 
       this.setDefaultValueInDateFn();
    //End
    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj?.[this.configData.name]) {
      let selectedDate = filterObj[this.configData.name];
      this.frmGroup.get(this.configData.name).setValue(selectedDate);
    }
  }
  //Alpha - Set validation values when date availble funstion 
    setDefaultValueInDateFn = () => {
    let copyOrderData = JSON.parse(localStorage.getItem('copyOrderData'));
    let validateObj = this.configData?.dateValidation;
    if(validateObj && validateObj?.isEnabledValue){
      let displayDate,
      currentDay = moment().utc().add(validateObj?.addInUTC).format('ddd').toUpperCase();
      if(validateObj?.cuttOffWeekend?.indexOf(currentDay) > -1 && validateObj?.cuttOfDayFallOn[currentDay] !== undefined) {
        displayDate = moment().add(validateObj?.cuttOfDayFallOn[currentDay], 'days').set(validateObj?.defaultTime);
      } else {
        let getFormatedTime = moment(validateObj?.cuttOffTime, validateObj?.timeFormat); //Get the current time
        let getCurrentUTCTime = moment().utc().add(validateObj?.addInUTC).format(validateObj?.timeFormat); //get the UTC time
        let cutOffTimeVailidation = moment(getCurrentUTCTime, "HH:mm").isAfter(getFormatedTime); //check cut off time
        let addedDays = cutOffTimeVailidation ? validateObj?.cuttOffTimeAfter : validateObj?.cuttOffTimeBefore; //checking added day/days in date
        if (validateObj?.offsetDateTimeFrom == 'systime'){ //check add the from date
          displayDate = moment().add(addedDays).set(validateObj?.defaultTime);
        } else { //add the days from the componets
          let componentDate = this.frmGroup.get(validateObj?.offsetDateTimeFrom).value;
          displayDate = moment(componentDate, validateObj?.dateFormat).add(addedDays).set(validateObj?.defaultTime);
        }
        //exclude weekend and add 1 new days
        if(validateObj ?. allowedWeekend == true)
        {
         // addedDays = 0;
          displayDate = displayDate.set(validateObj?.defaultTime);
        }
        else{
          while(validateObj?.cuttOffWeekend.indexOf(displayDate?.format('ddd').toUpperCase()) > -1){
            console.log("display date :::",displayDate?.format('ddd').toUpperCase())
            console.log("cutt off weekend :::",validateObj?.cuttOffWeekend.indexOf(displayDate?.format('ddd').toUpperCase()))
            displayDate = displayDate.add(addedDays, "days");
          }

        }
      }
      //set the date in fields
      this.frmGroup.get(this.configData.name).setValue(displayDate.format(this.configData?.displayFormat));
    } 
  }
  //End

  ngAfterViewChecked(){
    if(this.pickerToggle){
      this.positionCalendar();
    }
     if(this.configData?.defaultTimeSet){
      const [datePart] = this.frmGroup.get(this.configData?.name)?.value?.split(" ");
        if (datePart !== "") {
          this.frmGroup.get(this.configData?.name).setValue(`${datePart} ${this.configData?.defaultTimeSet}`)
        }
      }
  }
  // getOffset(el) {
  //   const rect = el.getBoundingClientRect();
  //   return {
  //     left: rect.left + window.scrollX,
  //     top: rect.top + window.scrollY
  //   };
  // }
  positionDrop() {

    const { left, top } = this.datepicker.nativeElement.getBoundingClientRect();

    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // let elemPosTop = this.datepicker.nativeElement.elOffsetTop;
    // let elOffsetTop = top + scrollTop;
    let elHeight = 413;
    // let heightOfDropdown = this.formControl.nativeElement.offsetHeight;
    if (window.innerHeight - top < elHeight) {
      this.pickerContainer.nativeElement.classList.add('bottom-position');
      this.pickerContainer.nativeElement.style.top = '-' + (elHeight - (window.innerHeight - top - 66) + 100) + "px";
      // this.pickerContainer.nativeElement.style.width = this.formControl.nativeElement.offsetWidth + "px";
    } else {
      this.pickerContainer.nativeElement.classList.remove('bottom-position');
      // this.pickerContainer.nativeElement.style.top = (heightOfDropdown-7) + "px";
      // this.pickerContainer.nativeElement.style.width = this.formControl.nativeElement.offsetWidth + "px";
    }

  }
  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['picker'] && this.picker !== undefined) {
  //     this.pickerToggle = this.picker;
  //   }
  // }

  fieldValueValidation(validations){
    validations.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);

      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name)['reqiired'] = false;
          this.frmGroup.get(this.configData.name).removeValidators([Validators.required]);
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
      if (element === "Numeric") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(1));
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^0*[1-9]\\d*$')));
      }
      else if (element === 'Decimal') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(1));
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^\\s*(?=.*[1-9])\\d*(?:\\.\\d{1,99})?\\s*$')));
      }
      else if (element === 'DecimalWithMaxlength') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp(/^\s*(?=.*[1-9])\d{1,3}(?:\.\d{1,2})?\s*$/)));
      }
      if (element === "NoSpecialCharacter") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^((?![$<>?%&*#!~`]).)*$')));
      }
      if (element === 'Email') {
        let newexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(newexp));
      }
      if (element === "customValidation") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(this.customValidator(validataion));
      }
    }, this);
  }

  toggleDisable(disabled){
    if (disabled === true) {
      this.frmGroup.get(this.configData.name).disable();
      // this.formControl.nativeElement.parentElement.classList.add('disabled');
      if(this.formControl)
        // this.formControl['_eref'].nativeElement.childNodes[0].childNodes[0].classList.add('disabled');
        this.formControl.nativeElement.childNodes[0].childNodes[0].classList.add('disabled');
    } else{
      this.frmGroup.get(this.configData.name).enable();
      // this.formControl['_eref'].nativeElement.childNodes[0].classList.remove('disabled');
      if(this.formControl)
        // this.formControl['_eref'].nativeElement.childNodes[0].childNodes[0].classList.remove('disabled');
        // this.formControl.nativeElement.parentElement.classList.remove('disabled');
        this.formControl.nativeElement.childNodes[0].childNodes[0].classList.remove('disabled');
    }
  }

  customValidator(validataionProps): ValidatorFn{
    let me = this;
    return (control): { [key: string]: any } | null => {
      let sourceControl = me.frmGroup.get(validataionProps['sourceControl']);
      if(!control.value || !sourceControl || !sourceControl.value || !sourceControl.value.value){
        return null;
      }
      let option = validataionProps.options.filter(option => option.value ==  sourceControl.value.value)[0];
      let newRegExp = new RegExp(option.pattern.toString());
      let forbidden = newRegExp.test(control.value);
      let validationMessage = option.message;
      control.markAsTouched();
      return !forbidden ? { customValidation: { value: control.value, 'message': validationMessage } } : null;
    }
  }

  onControlValueChange(e){
    // this.compareTwoDates(e);
  }
  // datepicker container creation start
  week = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'
  ];

  months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  monthTotalDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  currentDate;
  currentMonth;
  currentYear;
  currentDay;
  monthFirstDay;

  updatedMonth;
  updatedYear;

  dateObject;
  userSelectedDate = null;
  futureSelectionDay
  showCurrentDate(selectedDate?: Date){
    let date = selectedDate || new Date();

    if (!selectedDate && this.shouldApplyDynamicRules()) {
      const rules = this.configData.dateEnabled.dynamicRules;
      let defaultDynamicDate: moment.Moment | null = null;

      if (rules.from) {
        defaultDynamicDate = this.getDynamicFromDate();
      } else if (rules.to) {
        defaultDynamicDate = this.getDynamicFromDate();
      }

      if (defaultDynamicDate) {
        date = defaultDynamicDate.toDate();
      }
    }

    //  CP-8720 Appointment date earlies selection date should be two days from current date
    if (this.futureDateLimit) {
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + parseInt(this.futureDateLimit));
      date = currentDate; // Set date to current date + 2 days
      // this.futureSelectionDay = currentDate.getDate()
      if (currentDate.getMonth() === this.updatedMonth && currentDate.getFullYear() === this.updatedYear) {
        this.futureSelectionDay = currentDate.getDate();
      } else {
        this.futureSelectionDay = null; // fallback, so HTML uses currentDate
      }
    }
    //  CP-8720 Ends

    // NCP-13367 UI to use business days when putting the default next call date in the calendar
    if (this.configData?.excludeHolidays) {
      while (
        this.holidayDates.includes(this.formatDate(date)) ||
        date.getDay() === 0 ||  // Sunday
        date.getDay() === 6     // Saturday
      ) {
        date.setDate(date.getDate() + 1);
      }
    }
    // NCP-13367 ends here

    let cDate = date.getDate();
    let cMonth = date.getMonth();
    let cYear = date.getFullYear();
    let cDay = date.getDay();

    this.dateObject = date;
    this.currentDate = cDate;
    this.currentMonth = cMonth;
    this.currentYear = cYear;
    this.currentDay = cDay;

    this.updatedMonth = cMonth;
    this.updatedYear = cYear;
  //NCP-13630 DE573087 (PROD, UI)Default Callback calendar is not showing the correct days in the UI for July 2025 when opened
    let firstDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.monthFirstDay = (firstDate.getDay() - 1)  == -1 ? 6 : firstDate.getDay() - 1;

    //NCP-10300 start - 29/02 missing from the date picker in TOP
    if(new Date(this.updatedYear, 1, 29).getDate() === 29 && this.updatedMonth === 1){
      this.monthTotalDays[1] = 29;
    }
    else{
      this.monthTotalDays[1] = 28;
    }
    //NCP-10300 end

    // this.userSelectedDate =
    this.userSelectedDate = cDate;
    if(this.form && this.configData.timePicker){
      this.form = this.formInitialization();
    }
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  nextMonth(){
    this.clearDate(false, null);
    if(this.updatedMonth === 11){
      this.updatedYear += 1;

      this.updatedMonth = 0;

      this.dateObject.setDate(1);
      this.dateObject.setFullYear(this.updatedYear);
      this.dateObject.setMonth(this.updatedMonth);

      this.monthFirstDay = (this.dateObject.getDay() - 1)  == -1 ? 6 : this.dateObject.getDay() - 1;
    }
    else{
      this.updatedMonth += 1;
      if(new Date(this.updatedYear, 1, 29).getDate() === 29 && this.updatedMonth === 1)
        this.monthTotalDays[1] = 29;
      else
        this.monthTotalDays[1] = 28;

      this.dateObject.setDate(1);
      this.dateObject.setMonth(this.updatedMonth);
      this.monthFirstDay = (this.dateObject.getDay() - 1)  == -1 ? 6 : this.dateObject.getDay() - 1;
    }
  }

  previousMonth(){
    this.clearDate(false, null);
    if(this.updatedMonth === 0){
      this.updatedYear -= 1;
      this.updatedMonth = 11;

      this.dateObject.setDate(1);
      this.dateObject.setFullYear(this.updatedYear);
      this.dateObject.setMonth(this.updatedMonth);

      this.monthFirstDay = (this.dateObject.getDay() - 1)  == -1 ? 6 : this.dateObject.getDay() - 1;
    }
    else{
      this.updatedMonth -= 1;
      if(new Date(this.updatedYear, 1, 29).getDate() === 29 && this.updatedMonth === 1)
        this.monthTotalDays[1] = 29;
      else
        this.monthTotalDays[1] = 28;

      this.dateObject.setDate(1);
      this.dateObject.setMonth(this.updatedMonth);

      this.monthFirstDay = (this.dateObject.getDay() - 1)  == -1 ? 6 : this.dateObject.getDay() - 1;
    }
  }

  setSelected(e, date){
    this.clearDate(false, null);
    e.currentTarget.classList.add('active');
    this.userSelectedDate = date;

    this.fieldControl.markAsTouched();
    this.fieldControl.markAsDirty();
  }

  clearDate(emit=false, userEvent){
    let dateElem = document.getElementById('calendarDates');
    let hasData = this.frmGroup.get(this.configData.name).value;
    let count = dateElem.childElementCount
    for(var i = 0; i<count; i++){
      dateElem.children[i].classList.remove('active');
    }
    // do we really need below commented line?
    //#4548 : Input feild will be reset after click on button only.
    if(userEvent) {
      this.frmGroup.get(this.configData.name).reset();
      this.appService.compareTwoDates(null, this.configData, this.frmGroup);
    }
    //End

    //CP-2434 : datepicker validation for dataType = OBJECT type
    if(this.configData.required == true && this.configData['dataType'] && this.configData['dataType'] == 'OBJECT'){
      let error = {
        message: 'Required*',
       }
       error[this.configData.name] = true;
       this.frmGroup.get(this.configData.name).markAsTouched();
       this.frmGroup.get(this.configData.name).setErrors(error);
    }

    // dateElem.children.forEach(el=>{

    //   dateElem.children[0].classList.remove('active');
    // })
    this.filterDate = Constant.Filter_Popup_Status_All;
    this.userSelectedDate = null;
    // check if the date filter added, then call method to clear the date to parent component
    /*if(this.configData && this.configData['events'] && this.configData.type === 'FILTER' && emit){
      this.sendDataForFilter(this.userSelectedDate, userEvent);
      this.pickerToggle = false;
    }*/
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'CLEAR');
    if((event && hasData && emit) || (this.configData && this.configData['events'] && this.configData.type === 'FILTER' && emit)){
      this.sendDataForFilter(this.userSelectedDate, userEvent);
      this.pickerToggle = false;
      this.frmGroup.markAsTouched();
    }

    sessionStorage.removeItem(this.configData['storeDataName']);

    if(this.configData.timePicker){
      Object.keys(this.form.controls).forEach( element => {
        if(this.appService._components[element].configData.component === "DROPDOWN_DEFAULT_V2"){
          this.appService._components[element].reset()
        }
      })

      // this.form?.reset();
    }
    this.setFieldsAsRequired();
    // let elem = document.getElementById(this.userSelectedDate);
    // elem.classList.remove('active');
    // this.userSelectedDate = null;
  }


  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  isAllTimeFieldSelected() {
    if (this.configData.timePicker && this.form && this.form.valid && this.form.value &&
      this.form.get('HoursPicker') && this.form.get('HoursPicker').value &&
      this.form.get('MinutesPicker') && this.form.get('MinutesPicker').value
    ) {
      return true;
    }
    return false;
  }

  setSelectedDate(e){
    let d = this.userSelectedDate;
    let m = this.updatedMonth + 1;
    let y = this.updatedYear;

    if(this.configData.timePicker && !this.form.valid){
      for (let cont of Object.keys(this.form.controls)) {
        if (this.form.get(cont)?.invalid) {
          this.form.get(cont)?.markAsTouched();
        }
      }
      e.stopPropagation();
      return;
    }

    if(d !== null){
      let selectedDate =  (m < 10 ? '0' + m : m ) + '/' + (d < 10 ? '0' + d : d) +  '/' + y;

      if(this.configData.timePicker && this.isAllTimeFieldSelected()){
        this.timeObj = this.form.value;
        selectedDate += this.getTime()
      }
      //added check for changing the date format
      if(this.configData.hasOwnProperty("displayFormat") && this.configData.displayFormat.length > 0){
        selectedDate = this.appService.formatDateMoment(selectedDate, this.configData.displayFormat);
      }
      if( new Date(selectedDate) instanceof Date) {
        // this.formControl.nativeElement.classList.add('active');
        // this.formControl.nativeElement.classList.remove('error');

        // this.formatFormValue(selectedDate, true);//set form field value
        let val = this.appService.formatDateValueForCox(this.configData, selectedDate, true);//set form field value
        this.frmGroup.get(this.configData.name).setValue(val);

        this.appService.compareTwoDates(e, this.configData, this.frmGroup);

        this.filterDate = selectedDate;         // datepicker filter date
        this.pickerToggle = false;

        // check if the date filter added, then call method to send selected date to parent component
        if (this.configData && this.configData['events']) {
          let formattedDate = y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
          if(this.configData.timePicker){
           formattedDate += this.getTime()
          }

          this.sendDataForFilter(formattedDate, e);
        }
      }
    }
    this.pickerToggle = false;
    this.frmGroup.markAsTouched();
    e.stopPropagation();
    this.compareTwoInputAfterApplyFun();
    this.setFieldsAsRequired();
  }

  getTime() {

    let time = ' ';
    let index = 0;
    for (const property in this.timeObj) {
      time += this.timeObj[property];
      if (index === 0) {
        time += ':'
      }
      else if (index === 1) {
        time += ' '
      }
      index++;
    }
    return time;
  }

  getForm() {
    return this.form;
  }

  togglePicker() {
    if (this.configData?.dateEnabled?.dynamicRules) {
      this.initializeDateRange();
    }
    this.showCurrentDate();
      //Commenting below ALPHA code as it is creating issue in datepicker
      /*if(!this.configData.timePicker && this.fieldControl && this.fieldControl.value){
        const date = new Date(this.fieldControl.value);
        this.showCurrentDate(date);
      }*/
    this.pickerToggle = !this.pickerToggle;
    // this.positionDrop();
    this.minMaxValidationFun();
  }
  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target))
      this.pickerToggle = false;
    this.setFieldsAsRequired();
  }

  setFieldsAsRequired(){
    // Validate all form controls for required fields
    Object.keys(this.frmGroup.controls).forEach(controlName => {
      const control = this.frmGroup.get(controlName);
      const controlConfig = this.appService._components[controlName]?.configData;
      
      if (controlConfig?.required && controlConfig?.enableStepperValidation && (controlConfig.component === 'DATEPICKER' || controlConfig.component === 'DATEPICKER_V2')) {
        const fieldValue = control.value;
        const isEmpty = !fieldValue || fieldValue === '' || (typeof fieldValue === 'object' && (!fieldValue.displayValue || fieldValue.displayValue === ''));

        if (isEmpty) {
          control.markAsTouched();
          control.setErrors({ required: true });
        } else if (control.errors?.required) {
          control.setErrors(null);
          this.appService.compareTwoDates('', controlConfig, this.frmGroup);
        }
      }
    });

    if (this.configData?.required && this.frmGroup.get(this.configData.name)?.value === '') {
      this.frmGroup.get(this.configData.name).setErrors({ required: true });
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    } else {
      this.appService.compareTwoDates('', this.configData, this.frmGroup);
    }
  }

  sendDataForFilter(formattedDate, userEvent) {
    let queryString = '';
    if (formattedDate) {
      queryString = '&' + this.configData.name + '=' + formattedDate

      if (this.configData["timeZone"]) {
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        queryString = queryString + '&timeZone=' + tz;
      }
    }
    let events = this.configData.events;
    if (events && events.length > 0) {
      let eventData: DhlFormControlEventData = {
        event: events[0].event,
        eventData: events[0],
        action: events[0].action,
        name: this.configData.name,
        component: this,
        configData: this.configData,
        data: { value: formattedDate, queryString: queryString }
      }
      if (this.configData['storeDataName']) {
        sessionStorage.setItem(this.configData['storeDataName'], JSON.stringify(formattedDate))
      }
      eventData['userEvent'] = userEvent;

      let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
      if (filterObj) {
        filterObj[this.configData.name] = this.frmGroup.get(this.configData.name).value;
        this.alphaService.setFilteredObject('setFiltersValues', filterObj);
      }
      const formGroupHasErrors = this.alphaService.formGroupHasErrors(this.frmGroup);
      if (formGroupHasErrors && localStorage.getItem('filterCurrenturl') === '/upload') return;
      this.appService._commonComponentSubject.next(eventData);
    }
  }

  positionCalendar() {
    const { left, top } = this.formControlOuter.nativeElement.getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let elOffsetTop = top + scrollTop;
    let elOffsetLeft = left + scrollX;
    let elHeight = 414 + 150; //Height of Calendar (pickerContainer)
    if (this.configData.timePicker) { // If time picker, need to add time container height
      elHeight += 60;
    }
    let elWidth = 343; //Width of Calendar (pickerContainer)
    let headerHeight = 50; //Height of the header
    let stepperHeaderHeight = 0;
    if (elOffsetTop > elHeight) { // Add stepper header height to avoid cut off from stepper header.
      stepperHeaderHeight = 165;
    }

    const calendarSection = this.calendarSection.nativeElement;
    // if (window.innerHeight < elOffsetTop + elHeight) {​​​​​
    if (elOffsetTop > elHeight) {
      this.pickerContainer.nativeElement.classList.add('ulta');
      if (calendarSection) {
        const calendarSectionPosition = calendarSection.getBoundingClientRect();
        if (calendarSectionPosition.top < (headerHeight + stepperHeaderHeight)) {
          // calendarSection.style.marginTop = `${-140 - (elOffsetTop - (headerHeight + stepperHeaderHeight))}px`;
        }
      }
    } else {
      this.pickerContainer.nativeElement.classList.remove('ulta');
    }

    // if(elOffsetTop > elHeight){
    //   this.pickerContainer.nativeElement.classList.add('ulta');
    // }
    if(elOffsetLeft + elWidth > window.innerWidth){
      this.pickerContainer.nativeElement.classList.add('pulta');
    }else{
      this.pickerContainer.nativeElement.classList.remove('pulta');
    }
    if((left >  elWidth) && calendarSection){
      // calendarSection.style.left = this.formControlOuter.nativeElement.offsetWidth - elWidth + 'px';
    }
  }

  setValueToControl(value){
    console.log('Getting Value', value)
    if (value != undefined && value != "") {
      this.frmGroup.get(this.configData.name).setValue(value);
      //this.frmGroup.get(this.configData.name).setValue(this.setFormFieldValue(value));
    }else{
      this.showCurrentDate();
    }
  }

  setHover(value){
    if(this.configData.timePicker){
      this.hover = value;
    }
  }

  onFocusOutEvent(ev){
    let date = this.appService.compareTwoDates(ev, this.configData, this.frmGroup);
    if(this.configData.timePicker && this.hover){

      this.filterDate = this.frmGroup.get(this.configData.name).value;
      //let date = this.appService.compareTwoDates(ev, this.configData, this.frmGroup)

      if(!date.error){
        this.sendDataForFilter(this.filterDate, ev);
        this.setHover(false)
        }
    }
    this.compareTwoInputAfterApplyFun();
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);
  }

  ngOnDestroy() {
    if (this.clickEventSubscription)
      this.clickEventSubscription.unsubscribe();
  }

  minMaxValidationFun = () => {
    //min max date compares
    this.configData.validation.forEach(elm => {
      if (elm.indexOf('lessOrEqual') > -1) {
        let splitFeildsArray = elm.split('-').filter((val) => val != 'lessOrEqual');
        let oneInputName = splitFeildsArray.filter((val) => val != this.configData.name)[0];
        let oneInputDate = this.frmGroup.get(oneInputName).value;
        if (oneInputDate.length > 0) {
          this.filledInputDate = new Date(oneInputDate);
          this.compareType = splitFeildsArray.indexOf(oneInputName);
        } else {
          this.compareType = null;
        }
      }
    });
  }

  currentDateStatusFun = (day, month, year, type) => {
    let date = new Date(year, month, day);
    if (type == 1 && this.filledInputDate < date) {
      return true;
    } else if (type == 0 && this.filledInputDate > date) {
      return true;
    } else{
      return false;
    }
  }
  //Enable date from 'FROM' to 'TO' validation
 dateEnableFn = (day, month, year) => {
    let savedPODetsils = localStorage.getItem('selectedPoLines');
    savedPODetsils = savedPODetsils && JSON.parse(savedPODetsils)[0];

    let editableFromDate = null;
    if (this.editableFromDate) {
      editableFromDate = moment(this.editableFromDate, this.configData?.displayFormat).format('YYYY-MM-DD');
    } else {
      const dateEnabledFrom = this.configData?.dateEnabled?.from;
      if (dateEnabledFrom) {
        const computedFrom = dateEnabledFrom === 'today'
          ? moment()
          : dateEnabledFrom?.includes('-')
            ? moment().subtract(parseInt(dateEnabledFrom.split('-')[1]), dateEnabledFrom.split('-')[2])
            : this.frmGroup.get(dateEnabledFrom).value;
        this.editableFromDate = computedFrom;
        editableFromDate = moment(computedFrom, this.configData?.displayFormat).format('YYYY-MM-DD');
      }
    }

    let editableToDate = null;
    if (this.editableToDate) {
      editableToDate = moment(this.editableToDate, this.configData?.displayFormat).format('YYYY-MM-DD');
    } else {
      const dateEnabledTo = this.configData?.dateEnabled?.to;
      if (dateEnabledTo) {
        const getMonth = dateEnabledTo?.includes('-') ? parseInt(dateEnabledTo.split('-')[0]) : false;
        const computedTo = dateEnabledTo === 'today'
          ? moment()
          : getMonth
            ? moment().add(getMonth, dateEnabledTo.split('-')[1])
            : this.frmGroup.get(dateEnabledTo).value;
        this.editableToDate = computedTo;
        editableToDate = moment(computedTo, this.configData?.displayFormat).format('YYYY-MM-DD');
      }
    }

    let monthWith0 = +(month + 1) < 10 ? `0${(month + 1)}` : (month + 1);
    let dayWith0 = +day < 10 ? `0${day}` : day;
    let fullDate = dayWith0 + '-' + monthWith0 + '-' + year;
    fullDate = moment(fullDate, 'DD-MM-YYYY').format('YYYY-MM-DD');

    if (editableFromDate && editableToDate) {
      return moment(fullDate).isBetween(editableFromDate, editableToDate, undefined, '[]');
    }
    if (editableFromDate) {
      return moment(fullDate).isSameOrAfter(editableFromDate);
    }
    if (editableToDate) {
      return moment(fullDate).isSameOrBefore(editableToDate);
    }
    return true;
  }

  //END
  //manipulation other field with compare 2 input fields
  compareTwoInputAfterApplyFun = () => {
    this.configData.validation.forEach(elm => {
      if (elm.indexOf('greaterThan') > -1 && elm.indexOf('true') > -1) {
        let arrayOfValName = elm.split('-true-');
        let comparesNameArray = arrayOfValName[0].split('-greaterThan-');

        let greaterDate = this.frmGroup.get(comparesNameArray[0]).value; //input date Values

        let lessDate = this.frmGroup.get(comparesNameArray[1]).value; //input date values 

        let isDateAfter = moment(greaterDate).isAfter(lessDate) //true/false
        let validationName = arrayOfValName[1];
        let feildConfig;
        if (isDateAfter) {
          feildConfig = {
            action: 'TOGGLE',
            name: validationName,
            component: 'TOGGLESWITCH_V2',
            data: true
          }
        } else {
          feildConfig = {
            action: 'TOGGLE',
            name: validationName,
            component: 'TOGGLESWITCH_V2',
            data: false
          }
        }
        this.appService._valueTransferSub.next(feildConfig);
      }
    });

  }
}